/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Scene_NumberInputs */



/**
* | output |
* | --- |
* | "Sc. #" |
*
* @param {Ccsl_Export_Header_Scene_NumberInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_scene_number = /** @type {((inputs?: Ccsl_Export_Header_Scene_NumberInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Scene_NumberInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sc. #")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sc. #")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sc. #")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ск. №")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esc. #")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Sc. #")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Sc. #")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुसूचित जाति। #")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sc. #")
	return /** @type {LocalizedString} */ ("Sc. #")
});